import angular from 'angular';
import uiRouter from 'angular-ui-router';
import cpwdComponent from './cpwd.component';

let cpwdModule = angular.module('cpwd', [
  uiRouter
])

.component('cpwd', cpwdComponent)
.config(($stateProvider) => {
  "ngInject";
  $stateProvider
    .state('cpwd', {
      name:'cpwd',
      url: '',
      component: 'cpwd',
      params: {id: undefined}
    });
})
.name;

export default cpwdModule;



// WEBPACK FOOTER //
// ./client/app/common/cpwd/cpwd.js